import { ProductRankingPage } from './ProductRankingPage';

export const bestProductRouter = {
  '/@/goods/ranking': ProductRankingPage,
  '/@/hand-made/ranking': ProductRankingPage,
  '/@/brand-deals/ranking': ProductRankingPage,
  '/@/ebooks/ranking': ProductRankingPage,
};
